import React from 'react';

export const AddCurrency = () => {
    return ( <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.83325 1.16668C7.83325 0.706439 7.46016 0.333344 6.99992 0.333344C6.53968 0.333344 6.16658 0.706439 6.16658 1.16668V6.16668H1.16659C0.706348 6.16668 0.333252 6.53977 0.333252 7.00001C0.333252 7.46025 0.706348 7.83334 1.16659 7.83334H6.16658V12.8333C6.16658 13.2936 6.53968 13.6667 6.99992 13.6667C7.46016 13.6667 7.83325 13.2936 7.83325 12.8333V7.83334H12.8333C13.2935 7.83334 13.6666 7.46025 13.6666 7.00001C13.6666 6.53977 13.2935 6.16668 12.8333 6.16668H7.83325V1.16668Z" fill="#30A9A6"/>
    </svg>
    )
}
